import styled from 'styled-components'
import { IconButton } from '@shipt/design-system-buttons'
import { getBoxShadow } from '@/features/shared/styles/effects'
import { type ComponentProps } from 'react'

export const CarouselButton: typeof IconButton = styled(IconButton)`
  ${getBoxShadow('lift', 'light')}

  background-color: ${({ theme }) => theme.color.background.base.neutral.subtle_00};

  &:active {
    box-shadow: ${({ theme }) =>
      theme.shadow.lift.light.active
        .map(({ blur, color, spread, x, y }) => `${x}px ${y}px ${blur}px ${spread}px ${color}`)
        .join(', ')};
  }
`

const StyledTransparentButton = styled.button`
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  background: none;
  border: none;
  padding: 0;
`

type Props = ComponentProps<typeof StyledTransparentButton>

export const TransparentButton = ({ type, ...restProps }: Props) => {
  return <StyledTransparentButton {...restProps} type={type || 'button'} />
}

export const TransparentAnchor = styled.a`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  text-decoration: none;
  color: inherit;
`
